define(function (require) {


    const currency_field = require('../elements/v_itv_currency_field');
    const date_time_field = require('../elements/v_itv_date_time_field');
    const decimal_field = require('../elements/v_itv_decimal_field');
    const dropdown_field = require('../elements/v_itv_dropdown_field');
    const number_field = require('../elements/v_itv_number_field');
    const text_field = require('../elements/v_itv_text_field');
    const checkbox_field = require('../elements/v_itv_checkbox_field');
    const grid = require('../grid/v_lov_detail_grid');
    const label = require('../elements/v_itv_label');

    const editDelete = require('../elements/v_itv_edit_delete_icon');

    const IpsModel = require('civicsBase/ipsModel');
    const IpsModelCollection = require('civicsBase/ipsModelCollection');

    return Marionette.CollectionView.extend({
        tagName: 'tr',
        className: "grid-row",
        childEvents: {
            'deleteClicked': function (childView, model) {this.trigger('deleteRowClicked', this.values); },
            'editClicked': function (childView, model) {this.trigger('editRowClicked', this.values); }
        },
        initialize: function (options) {
			if (options.config) {
				//get a copy so changes we make don't overwrite upstream
				this.config = $.extend({},options.config);
            }
            this.values = options.values;
        },
        childViewOptions: function (model, index) {
            var ret = {
                config: this.config != null ? this.config : {},
                isGrid:true
            };
            //grid display is only read only.
            ret.config.readOnlyForm = true;

            //this.values contains the values for the row. The model contains the "element" data, like the bind, field type, etc. 
            //We add the fields value to the element data here so it is properly displayed in the appropriate element view.
            if (this.values) {
                var name = model.get('bind');
                if (this.values instanceof IpsModel && this.values.get(name) != undefined) {
                    //ret.config.value = this.values.get(name);
                    model.set('value', this.values.get(name));
                }
            }
            //determine if the delete and edit buttons should show up for this row.
            //the _new attribute is set when adding a row. it will not be present on rows from the database.
            if (model.get('type') == 'edit' || model.get('type') == 'delete') {
                var showEdit = false;
                var showDelete = false;
                if (this.values && this.values.get('_newRow')) {
                    showEdit = true;
                    showDelete = true;
                } else {
                    if (this.config.canEditExistingRows) {
                        showEdit = true;
                    }
                    if (this.config.canDeleteExistingRows) {
                        showDelete = true;
                    }
                }
                model.set({
                    showEdit: showEdit,
                    showDelete: showDelete
                });
            }
            return ret;
        },
        getChildView:function(child) {
            if (!_.isEmpty(child.get('type'))) {
                var fieldType = this.getFieldType(child);
                switch (fieldType) {
                    case 'decimal':
						return decimal_field;
					case 'currency':
						return currency_field;
                    case 'number':
                        return number_field;
                    case 'date_time':
                        return date_time_field;
                    case 'dropdown':
                        return dropdown_field;
                    case 'textbox':
                        return text_field;
                    case 'checkbox':
                        return checkbox_field;
                    case 'label':
                        return label;
                    case 'grid':
                        return grid;
                    case 'editdelete':
                        return editDelete;
                    default:
                }
            }
            return this.constructor;
        },
        templateHelpers: function () {
            return {
                showFieldSet: (this.type && this.type.toLowerCase() == 'panel' && this.text != null) ? true : false
            }
        },
        //End Marionette Functions
        getFieldType:function(child) {
            var type = child.get('type').toLowerCase();
            var fieldType = '';
            if (type == 'textbox') {
                var dataType = child.get('dataType');
                if (!_.isEmpty(dataType)) {
                    dataType = dataType.toLowerCase();
                    switch (dataType) {
						case 'system.decimal':
							if (child.get('format') && child.get('format').toLowerCase() == 'currency') {
								fieldType = 'currency'
							} else {
								fieldType = 'decimal'
							}
							break;
                        case 'system.single':
                            fieldType = 'decimal';
                            break;
                        case 'system.int16':
                        case 'system.int32':
                        case 'system.int64':
                            fieldType = 'number';
                            break;
                        case 'system.datetime':
                            fieldType = 'date_time';
                            break;
                        case 'system.string':
                            var moniker = child.get('moniker');
                            if (!_.isEmpty(moniker)) {
                                fieldType = 'dropdown';
                            } else {
                                fieldType = 'textbox';
                            }
                            break;
                        default:
                            fieldType = 'textbox';
                    }
                }
            } else if (type == 'checkbox') {
                fieldType = 'checkbox';
            } else if (type == 'dropdownbox') {
                fieldType = 'dropdown';
            } else if (type == 'label') {
                fieldType = 'label';
            } else if (type == 'panel') {
                fieldType = 'panel';
            } else if (type == 'table') {
                fieldType = 'grid';
            } else if (type == 'edit' || type == 'delete') {
                fieldType = 'editdelete'
            }
            return fieldType;
        }
    });
});